import { Input } from "../../input/input";

import { QuestionWithHeaderAndFooter } from "../question";
import { QuestionContent } from "../question-content";
import { SingleLineQuestionProps } from "../types";

export const SingleLineQuestion = (props: SingleLineQuestionProps) => {
  const {
    gap,
    required,
    invalid,
    className,
    layoutProps,
    labelClassName,
    questionId,
    questionLabel,
    accessibilityTextOfRequired,
    questionLabelProps,
    answer,
    placeholder,
    size,
    disabled,
    changeEventHandler,
    answerProps,
    contentClassName,
    answerAriaLabel,
    footerStackSpacing,
    note,
    maxNote,
    maxLength,
    errorMessage,
    errorMessageProps,
    withErrorIcon,
    noteProps,
    answerDataTestId
  } = props;

  const headerFooterProps = {
    gap,
    required,
    invalid,
    questionId,
    labelClassName,
    className,
    layoutProps,
    questionLabel,
    accessibilityTextOfRequired,
    questionLabelProps,
    footerStackSpacing,
    answerLength: answer?.length,
    note,
    maxLength,
    maxNote,
    errorMessage,
    errorMessageProps,
    withErrorIcon,
    noteProps
  };

  return (
    <QuestionWithHeaderAndFooter {...headerFooterProps}>
      <QuestionContent>
        <Input
          id={questionId}
          className={contentClassName}
          type="text"
          value={answer}
          placeholder={placeholder}
          onChange={changeEventHandler}
          maxLength={maxLength}
          disabled={disabled}
          aria-label={answerAriaLabel}
          {...answerProps}
          size={size}
          data-testid={answerDataTestId}
        />
      </QuestionContent>
    </QuestionWithHeaderAndFooter>
  );
};
